export const Role = {
    SUPER: "super",
    ADMIN: "admin",
    USER: "user",
    DEVELOPER: "developer",
    SUPPORT: "support",
    SERVICE: "service"
}

/**
 * Project-specific roles used for project level access control.
 * 
 * Example: $hasProjectAccessFor([pRole.ADMIN, pRole.SUPPORT, pRole.USER, pRole.GUEST])
 */
export const { DEVELOPER, SERVICE, SUPER,SUPPORT, ...pRole } = {
    ...Role, GUEST: 'guest'
}